import type { SurveyQuestion } from '../../../dtos/survey.dto'

export interface SurveyResponseFieldProps {
  question: SurveyQuestion
  value?: string | number
  onChange: (value: string | number | undefined) => void
  onBlur?: () => void
  disabled?: boolean
  error?: string
  touched?: boolean
  defaultPlaceholderText?: string
}
